import React from 'react'
import { Input, Button, message } from 'antd'
import firebase from '../../service/firebase'
import './Login.scss'


export default class Login extends React.Component {

    state = {
        process: false,
        email: '',
        password: '',
    }

    componentDidMount() {
    }

    onLogin() {
        this.setState({process: true})

        //Process Login..
        let { email, password } = this.state

        if(email !== 'myhuntcountry@gmail.com' && email !== 'admin@admin.com') {
            this.setState({process: false})
            message.error("Email or password wrong!")
            return
        }

        firebase.auth().signInWithEmailAndPassword(email, password).catch(error => {
            this.setState({
                process: false,
            })

            message.error(error.message)
        })
    }

    onChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }

    render() {
        return (
            <div className="login">

                <label className="title">Login to Admin</label>
            
                <Input type="text" 
                    placeholder="Email" 
                    dir="auto" 
                    value={this.state.email} 
                    onChange={evt => this.onChange('email', evt.target.value)} />  
            
                <Input type="password"
                    placeholder="Password"
                    dir="auto"
                    value={this.state.password}
                    onChange={evt => this.onChange('password', evt.target.value)} />  

                <Button loading={this.state.process} 
                    type="primary" 
                    onClick={() => this.onLogin()}>Log in</Button>
            </div>
        )
    }
}
